import React from "react";
import classes from "./Button.module.css";

//button used for simple clicks
//childern would be text which we pass eg: click,ok
const Button = (props) => {
  const btnClasses = `${classes.button} ${props.className}`;
  return (
    <button
      className={btnClasses}
      type={props.type || "button"}
      onClick={props.onClick}
      disabled={props.ondisabled}
    >
      {props.children}
    </button>
  );
};

export default Button;
